import { createAction } from '@ngrx/store';

export const loadContractAddresses = createAction('[Contract Addresses] Load');
